<h2 id="select-tmpl-info-title">{{ 'esploro.research.cv.page.info.title' | translate }}</h2>
@if (sections) {
  <section class="margin-bottom-md">
    <em class="info-text">{{ 'esploro.research.cv.page.info.message.1' | translate }}</em>
  </section>
}
@if (sections) {
  <section class="margin-bottom-md">
    <cdk-accordion
      (muloDropListA11yEditing)="onA11yEditing($event)"
      (muloDropListDropped)="drop($event)"
      muloDropList
      role="grid"
      aria-labelledby="select-tmpl-info-title"
      >
      @for (section of sections?.controls; track trackBy(i, section); let i = $index) {
        <mulo-expansion-panel
          #panel
          *muloDrag="section?.value?.order > 0"
          [formGroup]="sections.controls[i]"
          [headerLabel]="section.value.name | translateObject"
          [attr.aria-rowindex]="i + 1"
          >
          <mat-slide-toggle
            [aria-labelledby]="'expansion-header-title-' + panel._id"
            class="is-slim"
            color="primary"
            formControlName="active"
            slot="header-pre-label"
          ></mat-slide-toggle>
          @if (
            [
            'research.cv.asset',
            'research.cv.activity',
            'research.cv.project',
            'research.cv.grant'
            ].includes(section?.value.entryType)
            ) {
            <mulo-context-frame
                    [btnLabel]="
                        getEditBtnLabel(section) ||
                        ('esploro.research.cv.page.info.form.button.entrySettings' | translate)
                    "
              btnIcon="pencil"
              class="margin-left-sm margin-right-sm"
              >
              <!-- <span slot="closed-view" *ngFor="let tag of section?.value?.primaryFilter; let isLast = last">{{ tag  }}</span> -->
              <div class="settings-form-header">
                <mat-icon svgIcon="pencil"></mat-icon>
                <span class="padding-left-xs">{{
                  'esploro.research.cv.page.info.form.button.entrySettings' | translate
                }}</span>
              </div>
              <form class="settings-form">
                <mat-form-field>
                  <mat-label>{{ 'esploro.research.cv.page.info.select.entryType' | translate }}</mat-label>
                  <input [value]="section?.value.entryType | translate" disabled matInput />
                </mat-form-field>
                @if (cvCreationService.optionsMap[section.value.entryType]; as sectionStaticConfig) {
                  <div
                    class="section-filters"
                    >
                    <!-- PRIMARY FILTER -->
                    @if (sectionStaticConfig.primaryFilterList?.length) {
                      <mat-form-field>
                        <mat-label>{{
                          'esploro.research.cv.page.info.form.select.primaryFilter' | translate
                        }}</mat-label>
                        <mat-select [formControl]="section?.controls?.primaryFilter" multiple>
                          <!-- (click)="optionSelectionChange($event, source, section)" -->
                          @for (source of sectionStaticConfig.primaryFilterList; track source) {
                            <mat-option
                              (onSelectionChange)="optionSelectionChange($event, section)"
                              [value]="source"
                              >{{ source | translate }}</mat-option
                              >
                            }
                          </mat-select>
                        </mat-form-field>
                      }
                      <!-- SECONDARY FILTER -->
                      <mat-form-field>
                        <mat-label>{{
                          'esploro.research.cv.page.info.form.select.secondaryFilter' | translate
                        }}</mat-label>
                        @if (
                          !['research.cv.grant', 'research.cv.project'].includes(section.value.entryType)) {
                          <mat-select
                            [formControl]="section?.controls?.secondaryFilter"
                            multiple
                            >
                            @for (
                              group of sectionStaticConfig.secondaryFilterMap
                              | cvMapFilter : { primaryFilter: section.value.primaryFilter }
                              ; track
                              group) {
                              <mat-optgroup
                                [label]="group['primary'] | translate"
                                >
                                <!-- <mat-checkbox #groupCheckbox (change)="onGroupClick($event.checked, section?.controls?.secondaryFilter, group.secondaryList)"></mat-checkbox> -->
                                <!-- [ngStyle]="{'display': groupCheckbox.checked ? 'block' : 'none'}" -->
                                @for (source of group['secondaryList']; track source) {
                                  <mat-option [value]="source">{{
                                    source | translate
                                  }}</mat-option>
                                }
                              </mat-optgroup>
                            }
                          </mat-select>
                        } @else {
                          <mat-select [formControl]="section?.controls?.secondaryFilter" multiple>
                            @for (source of sectionStaticConfig.secondaryFilterList; track source) {
                              <mat-option
                                [value]="source"
                                >{{ source | translate }}</mat-option
                                >
                              }
                            </mat-select>
                          }
                          <ng-template #secondaryList>
                            <mat-select [formControl]="section?.controls?.secondaryFilter" multiple>
                              @for (source of sectionStaticConfig.secondaryFilterList; track source) {
                                <mat-option
                                  [value]="source"
                                  >{{ source | translate }}</mat-option
                                  >
                                }
                              </mat-select>
                            </ng-template>
                          </mat-form-field>
                        </div>
                      }
                      <mat-chip-set aria-label="Selected types" role="group">
                        @for (item of section.value.secondaryFilter; track item) {
                          <mat-chip
                            (removed)="removeSecondaryFilter(item, section)"
                            [removable]="true"
                            >
                            {{ item | translate }}
                            <button [attr.aria-label]="'Remove ' + (item | translate)" matChipRemove muloFacetChip>
                              <mat-icon muloSvgViewbox svgIcon="close"></mat-icon>
                            </button>
                          </mat-chip>
                        }
                      </mat-chip-set>
                    </form>
                  </mulo-context-frame>
                }
                @if (
                  [
                  'research.cv.asset',
                  'research.cv.activity',
                  'research.cv.project',
                  'research.cv.grant'
                  ].includes(section?.value.entryType)
                  ) {
                  <div
                    class="extra-fields"
                    >
                    <div class="date-range">
                      <esp-datepicker
                        [ngModel]="section?.controls?.['dateRange']?.value?.start"
                        (ngModelChange)="handleDateChange($event, section?.controls?.['dateRange'], 'start')"
                        [maxDate]="section?.controls?.['dateRange']?.value.end"
                        [isPartial]="true"
                        [ngModelOptions]="{ standalone: true }"
                        [translatedLabel]="'esploro.research.cv.page.info.form.FromDate' | translate"
                        partialType="year"
                        view="multi-year"
                        >
                      </esp-datepicker>
                      <div class="arrow-wrap">
                        <mat-icon class="mat-icon-rtl-mirror" svgIcon="arrow-right"></mat-icon>
                      </div>
                      <esp-datepicker
                        [ngModel]="section?.controls?.['dateRange']?.value.end"
                        (ngModelChange)="handleDateChange($event, section?.controls?.['dateRange'], 'end')"
                        [isPartial]="true"
                        [minDate]="section?.controls?.['dateRange']?.value.start"
                        [ngModelOptions]="{ standalone: true }"
                        [translatedLabel]="'esploro.research.cv.page.info.form.toDate' | translate"
                        partialType="year"
                        view="multi-year"
                        >
                      </esp-datepicker>
                    </div>
                    @if (cvCreationService.optionsMap[section.value.entryType].formatOptionList; as formatList) {
                      @if (formatList.length > 0) {
                        <div class="format-list">
                          <mat-form-field>
                            <mat-label>{{
                              'esploro.research.cv.page.info.form.field.format.asset' | translate
                            }}</mat-label>
                            <mat-select [formControl]="section?.controls?.format">
                              @for (source of formatList; track source) {
                                <mat-option [value]="source.code">
                                  {{ source['labelCode'] | translate }}
                                </mat-option>
                              }
                            </mat-select>
                          </mat-form-field>
                        </div>
                      }
                    }
                  </div>
                }
              </mulo-expansion-panel>
            }
          </cdk-accordion>
        </section>
      }
      <div class="next-btn-wrap">
        <button (click)="nextStep.emit()" class="padding-right-xs" color="primary" mat-flat-button>
          <div class="next-btn-content">
            {{ 'esploro.research.cv.page.button.next' | translate }}
            <mat-icon class="mat-icon-rtl-mirror" svgIcon="chevron-right"></mat-icon>
          </div>
        </button>
      </div>
